import type { CloudEnvironmentDiscoverer } from "../types/CloudEnvironmentDiscoverer";
import { pluggableAccountFunctions } from "../api/pluggableAccountFunctions";

let cloudEnvironmentDiscoverer: Promise<CloudEnvironmentDiscoverer> | undefined;

export async function getCloudEnvironmentDiscoverer(): Promise<CloudEnvironmentDiscoverer> {
    if (!cloudEnvironmentDiscoverer) {
        const loadCloudEnvironmentDiscoverer = pluggableAccountFunctions?.loadCloudEnvironmentDiscoverer;
        if (!loadCloudEnvironmentDiscoverer) {
            // Only the worker/native boot paths register the loader; other sessions never reach a
            // resolution cache miss that needs discovery.
            throw new Error("Cloud environment discoverer is not registered");
        }
        
        cloudEnvironmentDiscoverer = loadCloudEnvironmentDiscoverer().catch((error: unknown) => {
            // Don't cache a failed chunk load; clear the memo so a later call can retry.
            cloudEnvironmentDiscoverer = undefined;
            throw error;
        });
    }
    
    return cloudEnvironmentDiscoverer;
}
